import { Link } from "react-router-dom";
import { Copy, MessageCircle, Mail, CheckCircle } from "lucide-react";
import { toast } from "sonner";

/** Shown after a customer is created: UID, logins, password, with copy / WhatsApp / email sharing.
 *  created = { uid, status, snap: { company_name, contact_person, email, mobile, alt_mobile, password } } */
export default function CustomerCredentials({ created, loginUrl, onAnother, backTo = "/admin/customers" }) {
  const { uid, snap, status } = created;
  const lines = [
    "Welcome to Sendtoo! Your account is ready.",
    "",
    `Customer ID: ${uid}`,
    `Name: ${snap.company_name || snap.contact_person}`,
    `Login with your email: ${snap.email.trim().toLowerCase()}`,
    `or mobile: ${snap.mobile}`,
    ...(snap.alt_mobile ? [`Alternate contact number: ${snap.alt_mobile}`] : []),
    `Password: ${snap.password}`,
    "",
    `Login: ${loginUrl}`,
    "Please change your password after your first login.",
  ];
  const text = lines.join("\n");
  const copy = async () => {
    try { await navigator.clipboard.writeText(text); toast.success("Copied"); } catch { toast.error("Copy failed — select and copy manually"); }
  };
  const wa = `https://wa.me/91${snap.mobile}?text=${encodeURIComponent(text)}`;
  const mail = `mailto:${snap.email.trim()}?subject=${encodeURIComponent("Your Sendtoo account")}&body=${encodeURIComponent(text)}`;
  return (
    <>
      <div className="max-w-2xl space-y-4" data-testid="qc-credentials">
        <div className="flex items-center gap-2 text-emerald-700"><CheckCircle className="w-5 h-5" /><h1 className="font-heading text-xl font-bold uppercase">Customer created</h1></div>
        {status === "PENDING_APPROVAL" && <div className="text-sm bg-amber-50 border border-amber-200 rounded-md p-3 text-amber-800">This business customer is waiting in Customer Approvals. Share the login after it is approved.</div>}
        <pre className="bg-slate-50 border border-slate-200 rounded-lg p-4 text-sm whitespace-pre-wrap font-mono" data-testid="qc-credentials-text">{text}</pre>
        <div className="flex flex-wrap gap-2">
          <button onClick={copy} className="flex items-center gap-2 px-4 py-2 border border-slate-200 rounded-sm text-sm font-semibold hover:bg-slate-50" data-testid="qc-copy"><Copy className="w-4 h-4" /> Copy</button>
          <a href={wa} target="_blank" rel="noreferrer" className="flex items-center gap-2 px-4 py-2 bg-emerald-600 text-white rounded-sm text-sm font-semibold hover:bg-emerald-700" data-testid="qc-whatsapp"><MessageCircle className="w-4 h-4" /> Share on WhatsApp</a>
          <a href={mail} className="flex items-center gap-2 px-4 py-2 border border-slate-200 rounded-sm text-sm font-semibold hover:bg-slate-50" data-testid="qc-email-share"><Mail className="w-4 h-4" /> Email</a>
        </div>
        <div className="flex gap-4 text-sm pt-2">
          <button onClick={onAnother} className="text-brand-600 font-semibold underline" data-testid="qc-another">Create another customer</button>
          <Link to={backTo} className="text-slate-500 underline">Back to customers</Link>
        </div>
        <p className="text-xs text-slate-400">The password is shown only on this screen. Share it now.</p>
      </div>
    </>
  );
}
